import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/PageHeader";
import { usePageTitle } from "@/hooks/usePageTitle";
import { InboxProvider } from "@/components/inbox/InboxProvider";
import { InboxPage } from "@/components/inbox/InboxPage";

/** Full-page unified inbox route (/inbox). */
const Inbox = () => {
	const { t } = useTranslation();
	usePageTitle(t("inbox.title", "Inbox"));

	return (
		<InboxProvider variant="page">
			<div className="flex h-full min-h-0 flex-col p-4 md:pb-6 md:pl-12 md:pr-6 md:pt-1">
				<PageHeader title={t("inbox.title", "Inbox")} className="mb-4 shrink-0" />
				<div className="min-h-0 flex-1 overflow-hidden rounded-sm border border-border bg-background shadow-card">
					<InboxPage />
				</div>
			</div>
		</InboxProvider>
	);
};

export default Inbox;
